/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
//import moduleAuth from './store/auth/moduleAuth'
//import modeuleAuthState from '@/auth/authService'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {x: 0, y: 0}
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            breadcrumb: [{title: 'Dashboard', url: '/', active: true}],
            pageTitle: 'Dashboard',
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: {
            breadcrumb: [{title: 'Dashboard', url: '/dashboard', active: true}],
            pageTitle: 'Dashboard',
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/financials',
          name: 'financials',
          component: () => import('./views/financials/Financials.vue'),
          meta: {
            breadcrumb: [{title: 'Financials', url: '/financials', active: true}],
            pageTitle: 'Financials',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/reservations',
          name: 'reservations',
          component: () => import('./views/Reservations.vue'),
          meta: {
            breadcrumb: [{title: 'Reservations', url: '/reservations', active: true}],
            pageTitle: 'Reservations',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/specials',
          name: 'specials',
          component: () => import('./views/specials/Specials.vue'),
          meta: {
            breadcrumb: [{title: 'Specials', url: '/specials', active: true}],
            pageTitle: 'Specials',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/gifts',
          name: 'gifts',
          component: () => import('./views/gifts/Gifts.vue'),
          meta: {
            breadcrumb: [{title: 'Gifts', url: '/gifts', active: true}],
            pageTitle: 'Gifts',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/events',
          name: 'events',
          component: () => import('./views/events/Events.vue'),
          meta: {
            breadcrumb: [{title: 'Events', url: '/events', active: true}],
            pageTitle: 'Events',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/restaurant-sales',
          name: 'restaurant-sales',
          component: () => import('./views/restaurant-sales/RestaurantSales.vue'),
          meta: {
            breadcrumb: [{title: 'Restaurant Sales', url: '/restaurant-sales', active: true}],
            pageTitle: 'Restaurant Sales',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/property-management',
          name: 'property-management',
          component: () => import('./views/pages/property/PropertyManagement.vue'),
          meta: {
            breadcrumb: [{title: 'Property Management', url: '/property-management', active: true}],
            pageTitle: 'Property Management',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/register-restaurant',
          name: 'register-restaurant',
          component: () => import('./views/pages/register/RegisterRestaurant.vue'),
          meta: {
            breadcrumb: [{title: 'Register Restaurant', url: '/register-restaurant', active: true}],
            pageTitle: 'Register Restaurant',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/onboarding-form',
          name: 'onboarding-form',
          component: () => import('./views/onboardForm.vue'),
          meta: {
            breadcrumb: [{title: 'Onboarding Form', url: '/onboarding-form', active: true}],
            pageTitle: 'Onboarding Form',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/register-admin',
          name: 'register-admin',
          component: () => import('./views/pages/register/RegisterUser.vue'),
          meta: {
            breadcrumb: [{title: 'Register Administrator', url: '/register-admin', active: true}],
            pageTitle: 'Register Administrator',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import('./views/orders/Orders.vue'),
          meta: {
            breadcrumb: [{title: 'Orders', url: '/orders', active: true}],
            pageTitle: 'Orders',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/catering-orders',
          name: 'catering-orders',
          component: () => import('./views/catering-orders/Orders.vue'),
          meta: {
            breadcrumb: [{title: 'Catering Orders', url: '/catering-orders', active: true}],
            pageTitle: 'Catering Orders',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/onboarding-forms',
          name: 'onboarding-forms',
          component: () => import('./views/pages/onboarding-forms/OnboardingForms'),
          meta: {
            breadcrumb: [{title: 'Onboarding Forms', url: '/onboarding-forms', active: true}],
            pageTitle: 'Onboarding Forms',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/onboarding-forms/:formId',
          name: 'onboarding-form-detail',
          component: () => import('./views/pages/onboarding-forms/OnboardingFormDetails'),
          meta: {
            breadcrumb: [{title: 'Onboarding Forms', url: '/onboarding-forms', active: true}],
            pageTitle: 'Onboarding Form Detail',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          },
          props: true
  
        },
        {
          path: '/catering-order-details/:orderId',
          name: 'catering-order-details',
          component: () => import('./views/catering-orders/OrderDetails.vue'),
          meta: {
            pageTitle: 'Catering Order Details',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          },
          props: true
        },
        {
          path: '/order-details/:orderId',
          name: 'order-details',
          component: () => import('./views/orders/OrderDetails.vue'),
          meta: {
            pageTitle: 'Order Details',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          },
          props: true
        },
        {
          path: '/contents',
          name: 'contents',
          component: () => import('./views/pages/content/ContentManagement.vue'),
          meta: {
            breadcrumb: [{title: 'Contents', url: '/contents', active: true}],
            pageTitle: 'Contents',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/wholesale',
          name: 'Whole Sale',
          component: () => import('./views/shop/ECommerceWishList.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Whole Sale'},
              {title: 'Shop', active: true}
            ],
            pageTitle: 'Whole Sale',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/wholesale/wish-list',
          name: 'wholesale-wish-list',
          component: () => import('./views/shop/ECommerceWishList.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Whole Sale', url: '/wholesale'},
              {title: 'Wish List', active: true}
            ],
            pageTitle: 'Wish List',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/wholesale/checkout',
          name: 'wholesale-checkout',
          component: () => import('./views/shop/ECommerceCheckout.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Whole Sale', url: '/wholesale'},
              {title: 'Checkout', active: true}
            ],
            pageTitle: 'Checkout',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/wholesale/item/',
          redirect: '/wholesale/item/5546604',
          authRequired: true,
          minLevelRequired: [4]
        },
        {
          path: '/wholesale/item/:item_id',
          name: 'wholesale-item-detail-view',
          component: () => import('./views/shop/ECommerceItemDetailView.vue'),
          meta: {
            breadcrumb: [
              {title: 'Home', url: '/'},
              {title: 'Whole Sale'},
              {title: 'Shop', url: {name: 'wholesale-shop'}},
              {title: 'Item Details', active: true}
            ],
            parent: 'wholesale-item-detail-view',
            pageTitle: 'Item Details',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/menu',
          name: 'menu',
          component: () => import('./views/menu/Menu.vue'),
          meta: {
            breadcrumb: [{title: 'Menu', url: '/menu', active: true}],
            pageTitle: 'Menu',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/catering-menu',
          name: 'catering-menu',
          component: () => import('./views/catering-menu/Menu.vue'),
          meta: {
            breadcrumb: [{title: 'Menu', url: '/catering-menu', active: true}],
            pageTitle: 'Catering Menu',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/menu/:rid/add-product',
          name: 'menu-add-product',
          component: () => import('./views/menu/AddProduct.vue'),
          meta: {
            breadcrumb: [{title: 'Menu', url: '/menu', active: false}, {title:'Add Product', url:'/menu/:rid/add-product', active: false}],
            pageTitle: 'Add Product',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [3]
          }
        },
        {
          path: '/delivery-zones',
          name: 'delivery-zones',
          component: () => import('./views/pages/delivery-boundary/Delivery_Boundary.vue'),
          meta: {
            breadcrumb: [{title: 'Delivery Zones', url: '/delivery-zones', active: true}],
            pageTitle: 'Delivery Zones',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2, 3]
          }
        },
        {
          path: '/hours',
          name: 'hours',
          component: () => import('./views/hours/Hours.vue'),
          meta: {
            breadcrumb: [{title: 'Hours', url: '/hours', active: true}],
            pageTitle: 'Hours',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2, 3]
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/pages/restaurant-settings/Profile.vue'),
          meta: {
            breadcrumb: [{title: 'Profile', url: '/profile', active: true}],
            pageTitle: 'Profile',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/coupon-settings',
          name: 'coupon-settings',
          component: () => import('./views/promotions/Promotions_Manage.vue'),
          meta: {
            breadcrumb: [{title: 'coupon-settings', url: '/promotions-manage', active: true}],
            pageTitle: 'coupon-settings',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/promotions-reporting',
          name: 'promotions-reporting',
          component: () => import('./views/Promotions_Reporting.vue'),
          meta: {
            breadcrumb: [{title: 'Promotion Reports', url: '/promotions-reporting', active: true}],
            pageTitle: 'Promotion Reports',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [3]
          }
        },
        {
          path: '/reviews',
          name: 'reviews',
          component: () => import('./views/Reviews.vue'),
          meta: {
            breadcrumb: [{title: 'Reviews', url: '/reviews', active: true}],
            pageTitle: 'Reviews',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: []
          }
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/Users.vue'),
          meta: {
            breadcrumb: [{title: 'Users', url: '/users', active: true}],
            pageTitle: 'Users',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/account',
          name: 'account',
          component: () => import('./views/Account.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/statements',
          name: 'statements',
          component: () => import('./views/Statements.vue'),
          meta: {
            breadcrumb: [{title: 'Statements', url: '/statements', active: true}],
            pageTitle: 'Statements',
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/transactions',
          name: 'transactions',
          component: () => import('./views/Transactions.vue'),
          meta: {
            breadcrumb: [{title: 'Transactions', url: '/transactions', active: true}],
            pageTitle: 'Transactions',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/deposit-history',
          name: 'deposit-history',
          component: () => import('./views/Deposit_History.vue'),
          meta: {
            breadcrumb: [{title: 'Deposit History', url: '/deposit-history', active: true}],
            pageTitle: 'Deposit History',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/current-balance',
          name: 'current-balance',
          component: () => import('./views/Current_Balance.vue'),
          meta: {
            breadcrumb: [{title: 'Current Balance', url: '/current-balance', active: true}],
            pageTitle: 'Current Balance',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        },
        {
          path: '/restaurant-settings',
          name: 'restaurant-settings',
          component: () => import('./views/pages/restaurant-settings/Profile.vue'),
          meta: {
            breadcrumb: [{title: 'Restaurant Settings', url: '/restaurant-settings', active: true}],
            pageTitle: 'Restaurant Settings',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/catering-settings',
          name: 'catering-settings',
          component: () => import('./views/pages/restaurant-settings/Catering.vue'),
          meta: {
            breadcrumb: [{title: 'Catering Settings', url: '/catering-settings', active: true}],
            pageTitle: 'Catering Settings',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [2]
          }
        },
        {
          path: '/live-cities',
          name: 'live-cities',
          component: () => import('./views/pages/live-city/LiveCity.vue'),
          meta: {
            breadcrumb: [{title: 'Live Cities', url: '/live-cities', active: true}],
            pageTitle: 'Live Cities',
            rule: 'editor',
            authRequired: true,
            minLevelRequired: [4]
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import('@/views/pages/Logout.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/verify-mail/:token',
          name: 'verify-mail',
          component: () => import('@/views/pages/VerifyMail.vue'),
          props: true,
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor',
            authRequired: true
          }
        },
        {
          path: '/reset-password/:token',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          props: true,
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/lock-screen',
          name: 'page-lock-screen',
          component: () => import('@/views/pages/LockScreen.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ],
      meta: {
        rule: 'editor'
      }
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404',
      meta: {
        rule: 'editor'
      }
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach(async (to, from, next) => {

  const isLoggedin = await store.state.api.isUserLoggedIn()
  const currentUser = await store.state.api.currentUser


  if (to.name !== 'page-login' && to.name !== 'verify-mail' && to.name !== 'page-error-404' && to.name !== 'forgot-password' && to.name !== 'reset-password' && !isLoggedin) {
    if (to.fullPath !== '/') {
      next({name: 'page-login', query: {page: to.fullPath}})
    } else {
      next({name: 'page-login'})
    }
  } else if (to.name === 'onboarding-form' && isLoggedin) {
    next()
  } else if (to.name !== 'page-login' && isLoggedin) {
    if (currentUser.user_property['onBoarding'] === 1 || currentUser.user_group === 4 || to.name === 'logout') {
      if (to.meta.minLevelRequired) {
        if (to.meta.minLevelRequired.includes(currentUser.user_group) || currentUser.user_group === 4) {
          next()
        } else {
          next({name: 'page-error-404'})
        }
      } else {
        next()
      }
    } else {
      next({path: '/onboarding-form'})
    }
    
    
  } else if (isLoggedin) {
    next({path: '/dashboard'})
  } else {
    next()
  }

})
export default router
